import React from "react";
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PdfViewer = ({fileURL}) =>{
    const fileUrl = fileURL;
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    return (
        <div style={{ display:'block',maxHeight: '90vh',height:'100%' }}>
            <Viewer
                fileUrl={fileUrl}
                plugins={[defaultLayoutPluginInstance]}
            />
        </div>
    );
}

export default PdfViewer